module.exports = __webpack_public_path__ + "media/fonts/avenir/Avenir-Medium-d17ed7b7ba4436ec41ca08eff97fdc9b.ttf";